import { KeyRound } from "lucide-react";

import { PasswordChangeForm } from "@/components/password-change-form";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { t } from "@/i18n/pl";
import type { User } from "@/types/api";

/**
 * Full-screen trap shown right after first login (or an admin reset): the
 * account runs on a password IT chose, and the API refuses everything else
 * until the employee sets their own. The shared form signs back in with the
 * new password, so the trap simply dissolves into the app.
 */
export function ForcePasswordPage({ user }: { user: User }) {
  return (
    <div className="bg-sidebar flex min-h-svh flex-col items-center justify-center gap-8 p-6 md:p-10">
      <div className="animate-in fade-in slide-in-from-bottom-3 flex flex-col items-center gap-3 duration-500">
        <img src="/logo.png" alt="ZM SKIBA S.A." className="h-14 w-auto" />
        <p className="text-sidebar-foreground text-lg font-bold">{t.appName}</p>
      </div>

      <Card className="animate-in fade-in slide-in-from-bottom-2 w-full max-w-sm duration-500">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <KeyRound className="text-primary size-5" aria-hidden />
            {t.auth.forceChangeTitle}
          </CardTitle>
          <CardDescription>{t.auth.forceChangeBody}</CardDescription>
        </CardHeader>
        <CardContent>
          <PasswordChangeForm
            username={user.username}
            currentPasswordLabel={t.auth.currentPassword}
            submitLabel={t.auth.setPassword}
            successMessage={t.auth.passwordChanged}
          />
        </CardContent>
      </Card>
    </div>
  );
}
